import { network } from 'services/network';

import { QueryParams } from 'api/mutations/changeAssignee.mutation';

export const changeAssignee = (params: QueryParams) => {
    return network.post('api/bo/changeAssignee', params).then((response) => {
        return response.data;
    });
};
